export enum CoreRole {
    MiProAdmin = "MiPro Admin",
    SuperAdmin = "SuperAdmin",
    SystemTester = "SystemTester",
    OrganisationAdmin = "Organisation Admin",
    GovBodyAdmin = "Governing Body Admin",
    NonClinicalAdmin = "Non Clinical Admin",
    ClinicalAdmin = "Clinical Admin",
    Doctor = "Doctor",
    Therapist = "Therapist",
    StrengthAndConditioning = "Strength and Conditioning (S&C)",
    Nutritionist = "Nutritionist",
    Player = "Player",
    GenericLogin = "Generic User Login",
    GenericPatientLogin = "Generic Patient Login",
    ClinicalSafetyOfficer = "Clinical Safety Officer",
    PPS = "PPS"
}

export enum FormioRole {
    FormioExternalUser = "FormioExternalUser"
}
